import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: {
    zh: {},
    en: {}
  },
  silentFallbackWarn: true,
  silentTranslationWarn: process.env.NODE_ENV === 'production'
})

if (process.env.NODE_ENV !== 'production') {
  i18n.missing = (locale, key) => {
    // 仅开发环境提示缺失键，避免生产环境噪音
    // eslint-disable-next-line no-console
    console.warn(`[i18n] missing key: "${key}" in locale: "${locale}"`)
  }
}

export default i18n
